import create from "zustand";

type BalanceRollupState = {
  isMasterSubAccount: boolean;
  isShowingRollup: boolean;
  setIsMasterSubAccount: (isMasterSubAccount: boolean) => void;
  setIsShowingRollup: (isShowingRollup: boolean) => void;
  clearBalanceRollupStore: () => void;
};

const IS_SHOWING_ROLLUP = "isShowingRollup";

function setSessionStore(value: boolean) {
  if (sessionStorage) {
    localStorage.setItem(IS_SHOWING_ROLLUP, value.toString());
  }
}

function getSessionStore() {
  if (sessionStorage) {
    return localStorage.getItem(IS_SHOWING_ROLLUP) === "true";
  }
  return false;
}

const initialState = {
  isMasterSubAccount: false, // no need to store in sessionStorage
  isShowingRollup: getSessionStore(),
};

export const useBalanceRollupStore = create<BalanceRollupState>(set => ({
  ...initialState,
  clearBalanceRollupStore: () => {
    setSessionStore(false);
    set({
      isMasterSubAccount: false,
      isShowingRollup: false,
    });
  },
  setIsMasterSubAccount: isMasterSubAccount => {
    if (!isMasterSubAccount) {
      set({ isMasterSubAccount, isShowingRollup: false });
    }
    set({ isMasterSubAccount });
  },
  setIsShowingRollup: isShowingRollup => {
    setSessionStore(isShowingRollup);
    set({ isShowingRollup });
  },
}));
